import React, { useCallback } from "react";

import PlainButton from "../common/PlainButton";
import CaseIcon from "./CaseIcon";

function Header({
    onFlip,
    onReset,
    Dyn,
    onStackClick,
    onIconsClick,
    onCountClick,
    dynElemPlayContainer,
}) {
    const showActionButtons = dynElemPlayContainer?.canShowActionButtons;
    const disableResetButton = dynElemPlayContainer?.canDisableResetButton;
    // const disableFlipButton = dynElemPlayContainer?.canDisablePlotViewButton;
    const options = dynElemPlayContainer?.options || {};
    const onClick = useCallback(
        (type) => {
            switch (type) {
                case "flip":
                    onFlip();
                    break;
                case "reset":
                    onReset();
                    break;
                case "grid":
                    onStackClick();
                    break;
                case "icons":
                    onIconsClick();
                    break;
                case "count":
                    onCountClick();
                    break;
            }
        },
        [options, onFlip, onReset, onStackClick, onIconsClick, onCountClick]
    );
    return (
        <div className="tde-d-flex tde-elem-play-header">
            <PlainButton
                disabled={disableResetButton}
                className={
                    "tde-border tde-px-2 tde-py-2 tde-text-center"
                }
                onClick={() => {
                    onClick("reset");
                }}
            >
                <i className="tde-i tde-i-reset" style={{ fontSize: 30 }}></i>
                <br />
                <span className="tde-d-inline-block">Reset</span>
            </PlainButton>
            <div
                className={"tde-flex-1 tde-mx-1 tde-d-flex tde-justify-center"}
            >
                {showActionButtons && (
                    <>
                        <PlainButton
                            className={
                                "tde-border tde-px-2 tde-py-2 tde-text-center tde-mr-2" +
                                (options.isSpreadOut ? " tde-active" : "")
                            }
                            onClick={() => onClick("grid")}
                        >
                            <i
                                className="tde-i tde-i-up-down-arrow"
                                style={{ fontSize: 30 }}
                            ></i>
                            <br />
                            <span className="tde-d-inline-block">Spread</span>
                        </PlainButton>
                        <PlainButton
                            className={
                                "tde-border tde-px-2 tde-py-2 tde-text-center tde-mr-2" +
                                (options.isIconOnly ? " tde-active" : "")
                            }
                            onClick={() => onClick("icons")}
                        >
                            <div style={{ height: 30 }}>
                                <CaseIcon
                                    Dyn={Dyn}
                                    isActive={options.isIconOnly}
                                />
                            </div>
                            <span className="tde-d-inline-block">Icons</span>
                        </PlainButton>
                        <PlainButton
                            className={
                                "tde-border tde-px-2 tde-py-2 tde-text-center" +
                                (options.isShowingCount ? " tde-active" : "")
                            }
                            onClick={() => onClick("count")}
                        >
                            <i
                                className="tde-i tde-i-count"
                                style={{ fontSize: 30 }}
                            ></i>
                            <br />
                            <span className="tde-d-inline-block">Count</span>
                        </PlainButton>
                    </>
                )}
                {!showActionButtons && (
                    <h3
                        className="tde-h4 tde-mt-3"
                        style={{ fontWeight: "bold" }}
                    >
                        Play Area
                    </h3>
                )}
            </div>
            <PlainButton
                // disabled={!disableFlipButton}
                className={
                    "tde-border tde-px-2 tde-py-2 tde-mr-1 tde-text-center"
                }
                onClick={() => {
                    onClick("flip");
                }}
            >
                <i className="tde-i tde-i-switch" style={{ fontSize: 30 }}></i>
                <br />
                <span className="tde-d-inline-block">Plot View</span>
            </PlainButton>
        </div>
    );
}

export default Header;
